import CustomImage from "@components/custom-image";
import { useOrientation } from "@utils";
import { Container, Text, View } from "dripsy";
import * as React from "react";
import { Platform } from "react-native";

import BackButton from "./back-button";
import dgv from "../assets/logo.png";
import { useSafeArea } from "../provider/safe-area/use-safe-area";

function HeaderDetail({
  title,
  hasImage,
  backButton = true,
  withBottomBorder = true,
  right,
  marginTop = 0,
}: {
  title?: string;
  hasImage?: boolean;
  right?: any;
  withBottomBorder?: boolean;
  backButton?: boolean;
  marginTop?: number;
}) {
  const insets = useSafeArea();
  const orientation = useOrientation();

  const Wrapper = Platform.OS === "web" ? (Container as any as typeof View) : View;

  return (
    <View
      sx={{
        backgroundColor: "$secondaryBackground",
        borderBottomWidth: withBottomBorder ? 1 : 0,
        borderBottomColor: "#F8F6E8",
        pt: Platform.select({
          android: insets.top + 8,
          web: 10,
          default: insets.top + 8,
        }),
        paddingBottom: "$2",
        marginTop,
        zIndex: marginTop > 0 ? 9999 : 1,
      }}
    >
      <Wrapper
        sx={{
          flexDirection: "row",
          paddingLeft: 12 + insets.left,
          paddingRight: 12 + insets.right,
          alignItems: "center",
        }}
      >
        {backButton && Platform.OS !== "web" ? <BackButton /> : null}
        <View
          sx={
            backButton
              ? {
                  flex: 1,
                  alignItems: "center",
                }
              : { width: "100%", alignItems: "center" }
          }
        >
          {hasImage && Platform.OS !== "web" ? (
            <CustomImage source={dgv as any} sx={{ width: 138, height: 34 }} alt="logo" />
          ) : (
            <Text
              sx={{
                fontSize: 18,
                fontWeight: "700",
                alignSelf: "center",
                color: "$textSecondary",
              }}
            >
              {title}
            </Text>
          )}
        </View>
        <View
          sx={{
            width: 46,
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          {right}
        </View>
      </Wrapper>
    </View>
  );
}

export default HeaderDetail;
